module.exports = __webpack_public_path__ + "static/media/illustrator.549ecdfa.png";